<template>
  <div>

    <div class="form">
      <p class="title">绑定手机</p>
      <div class="form-item">
        <label>手机号码: </label>
        <input v-model="form.tel" type="number" placeholder="请输入手机号" />
      </div>
      <div class="form-item">
        <label>验证码: </label>
        <input v-model="form.code" type="number" class="codeInput" placeholder="请输入验证码" />
        <countDownBtn style="font-size: 0.22rem;" :title="'获取验证码'" class="code" @click.native="getcode" ref="countDown" />
      </div>
    </div>

    <div class="l-btn">
      <button @click="bindTel">确定</button>
    </div>
  </div>
</template>
<script>
import countDownBtn from '@/components/countDomnBtn'
import debounce from '@/utils/debounce'

import { getcode, setTel } from '@/api/user'

function checkPhone (num) {
  if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(num)) {
    this.$toast('请输入正确电话号码')
    return true
  } else {
    return false
  }
}

export default {
  components: {
    countDownBtn
  },
  data () {
    return {
      form: {
        tel: '',
        code: ''
      }
    }
  },
  methods: {
    async bindTel () {
      console.log(this.form);
      const result = await setTel(this.form)
      this.$toast(result.data.data.message)
      // if (result.data.data.status) {
      //   this.$router.replace({
      //     name: 'Home'
      //   })
      // }
    },
    getcode: debounce(async function () {
      if (checkPhone(this.form.tel)) return
      const result = await getcode({
        phone: this.form.tel,
        type: 'CHECK_USER_PHONE',
      })
      this.$toast(result.data.data.message)

      if (result.data.data.status) {
        this.$refs.countDown.start()
      } else {
        this.$refs.countDown.pause()
      }
    }, 200),
  }
}
</script>



<style lang="scss" scoped>
.form {
  font-size: 0.3rem;
  width: 6.35rem;
  background: #fff;
  margin: 3rem auto;
  padding: 0.2rem;
  .title {
    text-align: center;
    font-size: 0.6rem;
    background: $globalcolor;
    color: #fff;
    margin-top: 0;
    padding: 0.2rem 0;
  }
  .form-item {
    display: flex;
    justify-content: start;
    align-items: center;
    height: 0.5rem;
    margin: 0.2rem 0;
    label {
      width: 1.5rem;
    }
    input {
      margin: 0.1rem;
      width: 5rem;
      border: none;
    }
    .codeInput {
      width: 2.8rem;
    }
    border-bottom: 1px solid #bbbbbb;
    padding: 0.1rem 0;
  }
}

.l-btn {
  text-align: center;
  margin-top: 2rem;
  button {
    width: 4.68rem;
    height: 0.99rem;
    border-radius: 30px;
    border: none;
    color: white;
    background: $globalcolor;
    font-size: 0.32rem;
  }
}

.code {
  height: 100%;
  width: 2rem;
  border: none;
  background: #fff;
}
</style>